// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-containment-field {
   padding: var(--padding);
   border-radius: var(--border-radius);
   background-color: var(--sub-window-bg);
   width: 100%;
}

.ai-chat-window {
   padding: var(--padding);
   min-height: 100px;
   max-height: 600px;
   overflow: auto;
}

.ai-chat-row {
   margin-left: var(--margin);
   display: flex;
   flex-wrap: wrap;
}

.ai-chat-row p {
   padding: 0;
}
.ai-chat-row img {
   margin: var(--margin);
   width: 35px;
   height: 35px;
}

.ai-chat-row .user-info-container {
   align-items: unset;
}

.ai-chat-row-content {
   display: flex;
   flex-direction: column;
   justify-content: center;
   /*img + margin = 45px*/
   max-width: calc(100% - 45px);
}

.ai-chat-row-identity {
   font-weight: bold;
}

.ai-chat-row-identity span {
   font-weight: normal;
   font-style: italic;
   font-size: smaller;
}

.ai-chat-submission {
   display: flex;
   margin: var(--margin);
}

.ai-chat-submission button {
   margin: var(--margin)
}

.ai-chat-submission input {
   margin: var(--margin);
   min-width: 150px;
   cursor: text !important;
}

.ai-chat-row .ai-table {
   width: 100%;
   display: flex;
   justify-content: center;
   height: 310px;
}

.ai-chat-response {
   display: flex;
   flex-direction: column;
   width: 100%;
   padding: var(--padding-sm);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/AskSourceOne/AskSourceOne.css"],"names":[],"mappings":"AAAA;GACG,uBAAuB;GACvB,mCAAmC;GACnC,sCAAsC;GACtC,WAAW;AACd;;AAEA;GACG,uBAAuB;GACvB,iBAAiB;GACjB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,0BAA0B;GAC1B,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,UAAU;AACb;AACA;GACG,qBAAqB;GACrB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,sBAAsB;GACtB,4BAA4B;AAC/B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,mBAAmB;GACnB,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,qBAAqB;AACxB;;AAEA;GACG;AACH;;AAEA;GACG,qBAAqB;GACrB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,WAAW;GACX,aAAa;GACb,uBAAuB;GACvB,aAAa;AAChB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,WAAW;GACX,0BAA0B;AAC7B","sourcesContent":[".ai-containment-field {\r\n   padding: var(--padding);\r\n   border-radius: var(--border-radius);\r\n   background-color: var(--sub-window-bg);\r\n   width: 100%;\r\n}\r\n\r\n.ai-chat-window {\r\n   padding: var(--padding);\r\n   min-height: 100px;\r\n   max-height: 600px;\r\n   overflow: auto;\r\n}\r\n\r\n.ai-chat-row {\r\n   margin-left: var(--margin);\r\n   display: flex;\r\n   flex-wrap: wrap;\r\n}\r\n\r\n.ai-chat-row p {\r\n   padding: 0;\r\n}\r\n.ai-chat-row img {\r\n   margin: var(--margin);\r\n   width: 35px;\r\n   height: 35px;\r\n}\r\n\r\n.ai-chat-row .user-info-container {\r\n   align-items: unset;\r\n}\r\n\r\n.ai-chat-row-content {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   /*img + margin = 45px*/\r\n   max-width: calc(100% - 45px);\r\n}\r\n\r\n.ai-chat-row-identity {\r\n   font-weight: bold;\r\n}\r\n\r\n.ai-chat-row-identity span {\r\n   font-weight: normal;\r\n   font-style: italic;\r\n   font-size: smaller;\r\n}\r\n\r\n.ai-chat-submission {\r\n   display: flex;\r\n   margin: var(--margin);\r\n}\r\n\r\n.ai-chat-submission button {\r\n   margin: var(--margin)\r\n}\r\n\r\n.ai-chat-submission input {\r\n   margin: var(--margin);\r\n   min-width: 150px;\r\n   cursor: text !important;\r\n}\r\n\r\n.ai-chat-row .ai-table {\r\n   width: 100%;\r\n   display: flex;\r\n   justify-content: center;\r\n   height: 310px;\r\n}\r\n\r\n.ai-chat-response {\r\n   display: flex;\r\n   flex-direction: column;\r\n   width: 100%;\r\n   padding: var(--padding-sm);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
